import { Barcode, Text, Colorfilter } from 'iconsax-react';
import { AES, enc } from 'crypto-js';
import * as url from "../store/constant/Endpoints";
const icons = {
    navigation: Barcode,
    typography: Text,
    color: Colorfilter,
    shadow: Barcode
};


let permissionUser = localStorage.getItem('data');

let decryptedData = null;
if (permissionUser) {
    try {
        decryptedData = AES.decrypt(permissionUser, url.encryptionSecret).toString(enc.Utf8);
    } catch (error) {
        console.log(error, "er")
    }
}

const permissions = JSON.parse(decryptedData)?.permissions;

const allowedPermissions = permissions && permissions.length !== 0 ? permissions?.map(permission => permission?.permission) : [];

const permissionsAccessFunction = (brand) => {
    return allowedPermissions && allowedPermissions.length !== 0 && allowedPermissions?.some(permission => permission?.includes(brand));
}

const oAuthItem = permissionsAccessFunction('oauth-manage') ? {
    id: 'oauth-utilities',
    title: 'Manage oauth',
    icon: icons.navigation,
    type: 'group',
    children: [

        true ? {
            id: 'all-o-auth',
            title: 'OAuth',
            type: 'item',
            url: '/oauth/all-o-auth',
            icon: icons.navigation,
            breadcrumbs: true
        } : null,
    ].filter(Boolean)
} : null;

export default oAuthItem;
